/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./federatedLogin.vue?vue&type=template&id=3c39b66e&scoped=true"
import script from "./federatedLogin.vue?vue&type=script&lang=js"
export * from "./federatedLogin.vue?vue&type=script&lang=js"
import style0 from "./federatedLogin.vue?vue&type=style&index=0&id=3c39b66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39b66e",
  null
  
)

export default component.exports